var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.container },
    [
      _c(
        "div",
        { class: _vm.$style.header },
        [
          _c("NsHeaderProfileToggle", {
            attrs: {
              "dropdown-open": _vm.dropdownOpen,
              greeting: _vm.translations.greeting,
              "hide-sign-up": _vm.hideSignUp,
              "sign-in-label": _vm.translations.signIn,
              "sign-up-label": _vm.translations.signUp,
            },
            on: { toggle: _vm.handleDropdownToggle },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.$style.closeButton,
              on: { click: _vm.handleCloseClick },
            },
            [
              _c("NsIcon", {
                class: _vm.$style.closeIcon,
                attrs: {
                  "icon-name": "icon-close-24",
                  size: "custom",
                  "data-testid": "profileDropdownMobileClose",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "NsAnimateHeight",
        { attrs: { open: _vm.dropdownOpen } },
        [
          _c("NsHeaderProfile", {
            attrs: {
              "hide-sign-up": _vm.hideSignUp,
              "profile-menu": _vm.profileMenu,
              "sign-out-url": _vm.signOutUrl,
              "sign-up-url": _vm.signUpUrl,
              translations: _vm.translations,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }